import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.settings?.onboarding_completed) return <Navigate to="/onboarding" replace />;
  const levels = { USER: 1, MODERATOR: 2, ADMIN: 3, SUPER_ADMIN: 4 };
  if (requireRole && (levels[user.role] || 0) < levels[requireRole]) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
